import React, { useState, useEffect } from 'react'
import { Dialog, DialogContent, DialogTitle, Tooltip, LinearProgress } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Add } from '@mui/icons-material';
import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import voucherServices from '../voucherServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';
import { add } from 'ckeditor5';

function JournalVoucherForm({ data, callBack }) {
    const { AppAlert } = useAlert();
    const { ledgerDD } = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [formValues, setFormValues] = useState(null);

    const navigate = useNavigate();

    const initialValues = {
        voucherType: 'Journal',        
        voucherNo: "",
        voucherDate: moment().format(moment.HTML5_FMT.DATE),
        ledgerId: "",           // Debit Ledger (Dr.)
        paymentLedgerId: "",    // Credit Ledger (Cr.)
        grandTotal: "",
        narration: "",
    }

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            voucherType: data.voucherType,      
            voucherNo: data.voucherNo,
            voucherDate: data.voucherDate,
            ledgerId: data.ledgerId,
            paymentLedgerId: data.paymentLedgerId,
            grandTotal: data.grandTotal,
            narration: data.narration
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        //voucherNo: Yup.string().required("Required"),
        voucherDate: Yup.string().required("Required"),
        ledgerId: Yup.string().required("Debit account required"),
        paymentLedgerId: Yup.string()
            .required("Credit account required")
            .test('not-same', 'Debit and Credit accounts must be different', function(value) {
                return value !== this.parent.ledgerId;
            }),
        grandTotal: Yup.number().moreThan(0, 'Amount cannot be zero').required("Required"),
    });

    const onSubmit = (values) => {
        setSavingStatus(true);
        voucherServices.save(values).then(res => {
            AppAlert(res.msg);
            if (!data) navigate("/voucher/contra-journal/details/" + res.id);
            if (callBack) callBack();
            setDialogStatus(false);
        }).catch(error => {
            AppAlert(error.msg, "error");
        }).finally(() => setSavingStatus(false));
    }

    useKeyPress('F7', addNew);

    return (
        <>
            {!data ? (
                <Tooltip title="Add Journal Adjustment">
                    <button type="button" className='btn btn-default w-100 text-start' onClick={addNew}>
                        <Add/> Journal Voucher
                        <span style={{ fontSize: '0.85em', opacity: 0.7, marginLeft: '8px' }}>(F7)</span>
                    </button>
                </Tooltip>
            ) : (
                <button className="btn btn-outline-dark me-2" onClick={updateData}>Edit Journal</button>
            )}

            <Dialog open={dialogStatus} onClose={() => setDialogStatus(false)} fullWidth maxWidth="md">
                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {(formik) => (
                        <Form>
                            <DialogTitle style={{ color: '#b08d57' }}>Journal Voucher (Adjustment)</DialogTitle>
                            <DialogContent>
                                {data &&
                                <div className="row">
                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" formik={formik} type="text" label="Voucher Number" name="voucherNo" />
                                    </div>
                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" formik={formik} type="date" label="Voucher Date" name="voucherDate" />
                                    </div>
                                </div>
                                }
                                <hr />
                                <div className='row'>
                                    <div className='col-md-6 my-2'>
                                        <FormikControl control="autoselect" formik={formik} autoFocus
                                            label="Debit (Dr) Ledger (To)
                                                " name="ledgerId" 
                                            options={ledgerDD} multiple={false} 
                                        />
                                    </div>
                                    <div className='col-md-6 my-2'>
                                        <FormikControl control="autoselect" formik={formik} 
                                            label="Credit (Cr) Ledger (From)" name="paymentLedgerId" 
                                            options={ledgerDD} multiple={false} 
                                        />
                                    </div>
                                    <div className="col-md-4 my-2">
                                        <FormikControl control="input" formik={formik} type="number" label="Adjustment Amount" name="grandTotal" />
                                    </div>
                                    <div className="col-md-8 my-2">
                                        <FormikControl control="input" formik={formik} type="text" label="Narration / Remarks" name="narration" />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className='col-md-12'>
                                        {savingInProgress ? <LinearProgress/> : (
                                            <>
                                                <button className="btn btn-primary float-end" type="submit" style={{ backgroundColor: '#1a4331' }}>Save Journal</button>
                                                <button className="btn btn-outline-primary" type="button" onClick={() => setDialogStatus(false)}>Cancel</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    )
}

export default JournalVoucherForm;